module.exports = __webpack_public_path__ + "static/media/b400b845041cd6e0d413fe8aefe3a25.c5bc8e39.jpg";